import { cn } from "@utils/tw"
import { dynamic } from "eddev/dynamic"
import { useForm } from "@hooks/queries"
import { motion, AnimatePresence } from "framer-motion"
import { useSignup } from "@hooks/useSignup"
import { Heading } from "@components/atoms/Heading"
import { VSpace } from "@components/layout/Spacer"
import { Typography } from "@components/atoms/Typography"
import { CLOSE } from "@components/atoms/Icons"

const GravityForm = dynamic(() => import("@components/forms/organisms/GravityForm"), "GravityForm")

export const FormPopup = ({ fueltrack }: { fueltrack?: boolean }) => {
  const form = useForm({ id: fueltrack ? "3" : "2" })
  const showSignup = useSignup()

  if (form.data?.gravityForm)
    return (
      <AnimatePresence>
        {showSignup.open && (
          <motion.div className="fixed inset-0 z-[100] transition-all duration-700 ease-menu">
            <div
              className={cn(
                "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[2] w-[80vw] max-w-[680px] max-h-[90vh]",
                "bg-light-white p-7 rounded-md border border-grey overflow-auto",
                "[&_.checkbox-group]:flex [&_.checkbox-group]:flex-wrap [&_.checkbox-group]:gap-3 [&_.checkbox-group]:my-2",
                "[&_.radio-group]:flex [&_.radio-group]:flex-wrap [&_.radio-group]:gap-3 [&_.radio-group]:my-2",
                "[&_.checkbox-group>div]:w-[calc((100%-var(--spacing-3))*(1/2))] [&_.radio-group>div]:w-[calc((100%-var(--spacing-3))*(1/2))]",
                "lg:[&_.checkbox-group>div]:w-[calc((100%-(var(--spacing-3)*2))*(1/3))] lg:[&_.radio-group>div]:w-[calc((100%-(var(--spacing-3)*2))*(1/3))]",
                "[&_footer]:mt-6 [&_footer]:pt-6 [&_footer]:border-t [&_footer]:border-black [&_footer_button.button]:float-right",
                "lg:[&_main>div:last-of-type]:absolute lg:[&_main>div:last-of-type]:top-full lg:[&_main>div:last-of-type]:max-w-[60%] lg:[&_main>div:last-of-type]:mt-[calc((var(--spacing-6)+var(--spacing-6))-15px)]",
              )}
            >
              <button
                className="appearance-none border-none bg-transparent flex items-center justify-center absolute top-7 right-7 w-[20px] h-[20px]"
                onClick={() => showSignup.setOpen(false)}
              >
                {CLOSE}
              </button>
              <Heading as="h3" variant="h3">
                {form.data.gravityForm.form.title}
              </Heading>
              <VSpace initial={4} />
              <Typography variant="text-m">{form.data.gravityForm.form.description}</Typography>
              <VSpace initial={6} />
              <GravityForm form={form.data.gravityForm.form} />
            </div>
            <div
              className="absolute inset-0 z-[1] bg-[rgba(255,255,255,0.75)] cursor-pointer"
              onClick={() => showSignup.setOpen(false)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    )

  return <></>
}
